module.exports = __webpack_public_path__ + "static/media/face-with-symbols-on-mouth-svgrepo-com.58f90806.svg";